<div class="app-container">
  <loading-spinner
    [isLoading]="queryDepot.isPending() || queryDepot.isFetching()"
    [classesString]="'top-50'"
  ></loading-spinner>
  @if (!isLoading()) {
    <form
      [formGroup]="depotForm"
      (ngSubmit)="isCreating() ? createDepotMutation.mutate() : updateDepotMutation.mutate()"
    >
      <page-header
        [icon]="'far-building'"
        [title]="isCreating() ? 'depot.new' : ''"
        [appendNoTranslationTitlePart]="isCreating() ? '' : queryDepot.data()?.name"
      >
        <ng-container class="header-button">
          <btn
            [label]="'save'"
            [title]="'save' | translate"
            [classes]="['btn-first', 'float-right']"
            [icon]="'far-check'"
            [btnType]="'submit'"
            [isLoading]="createDepotMutation.isPending() || updateDepotMutation.isPending()"
            [spinnerClassesString]="'spinner-white'"
            [btnDisabled]="!!depotForm.errors"
            [dataCyAttribute]="'create-depot'"
          ></btn>
          @if (!isCreating()) {
            <btn
              [btnType]="'button'"
              [label]="'delete'"
              [title]="'delete' | translate"
              [classes]="['btn-first-red', 'float-right', 'me-2']"
              [icon]="'far-trash-alt'"
              (onEvent)="deleteDepotMutation.mutate()"
              [dataCyAttribute]="'delete-depot'"
              [btnDisabled]="isLoading()"
            ></btn>
            <modal-loggable-history [objectClass]="'Depot'" [objectId]="depotId()"></modal-loggable-history>
          }
        </ng-container>
        <ng-container class="back-button">
          <btn
            [label]="'back'"
            [title]="'back' | translate"
            [isBackButton]="true"
            [classes]="['btn-third', 'float-right', 'me-2']"
            [icon]="'far-arrow-left'"
            (onEvent)="goBack()"
          ></btn>
        </ng-container>
      </page-header>
      <section class="content">
        <div class="card">
          <div class="row">
            <div class="col-sm-3">
              <form-row-input
                [label]="'depot.name'"
                [formGroup]="depotForm"
                formControlName="name"
                [required]="depotForm.get('name').errors !== null && depotForm.get('name').errors.required"
                [requiredCssClass]="submitted() && formControls.name.errors"
                [dataCyAttribute]="'name'"
              ></form-row-input>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <form-row-input
                [label]="'email'"
                [formGroup]="depotForm"
                formControlName="emailIn"
                [dataCyAttribute]="'emailIn'"
              ></form-row-input>
            </div>
          </div>
        </div>
      </section>
    </form>
  }
</div>
